// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__bE7Nq","Logo":"Toolbar_Logo__3E_Oy","DesktopOnly":"Toolbar_DesktopOnly__1Qe_A"};